<template>
  <el-row>
    this is 毕业离校
  </el-row>
</template>

<script>
export default {}
</script>

<style></style>
